// extracted by mini-css-extract-plugin
export default {"socials":"Footer_socials__0mIfs","socialIcon":"Footer_socialIcon__Tu4bs"};